import React, { Component } from "react";
import MeasuredStoryMixerGroup from './MeasuredStoryMixerGroup';
import './storyMixerFeature.less';
import StoryMixerCategory from 'models/StoryMixerCategory';
import PropTypes from 'prop-types';

class StoryMixerFeature extends Component {
	constructor() {
		super();
		this.state = { currentHoveredTerm: null };

		this.setHoveredTerm = this.setHoveredTerm.bind(this);
	}

	setHoveredTerm(termData) {
		this.setState({ currentHoveredTerm: termData });
	}

	renderStoryMixerRows() {
		const { storyMixerCategoryList, ...propsToPass } = this.props;

		const storyMixerRows = this.props.storyMixerCategoryList.map((storyMixerCategory, index) => {
			// pass in the genres to storyMixer terms
			return (
				<MeasuredStoryMixerGroup
					key={index}
					categoryName={storyMixerCategory.name}
					storyMixerTerms={storyMixerCategory.termList}
					setHoveredTerm={this.setHoveredTerm}
					{...propsToPass}
				/>
			);
		});
		return storyMixerRows;
	}

    /**
     * Displays the definition of the term when it is hovered over in the story mixer.
     */
	renderCurrentDescription() {
		let content;

		if (this.state.currentHoveredTerm && this.state.currentHoveredTerm.description) {
			content = (
				<div className="story-mixer-description">
					<span className="story-mixer-description-name">{this.state.currentHoveredTerm.name}: </span>
					<span>{this.state.currentHoveredTerm.description}</span>
				</div>
			);
		} else {
			content = (<div className="story-mixer-description" />);
		}

		return content;
	}

	render() {
		return (
			<div className="story-mixer-feature">
				<div className="story-mixer-instruction">
					Mix and match to explore similar stories:
                </div>
				{this.renderStoryMixerRows()}
				{this.renderCurrentDescription()}
			</div>
		);
	}
}

StoryMixerFeature.propTypes = {
	storyMixerCategoryList: PropTypes.arrayOf(PropTypes.instanceOf(StoryMixerCategory)).isRequired,
}

export default StoryMixerFeature;



// WEBPACK FOOTER //
// ./src/react/views/storyMixer/StoryMixerFeature.jsx